import React from "react";
import PropTypes from "prop-types";
import { Popup } from "react-map-gl";

const Tooltip = ({ item, offsetTop, nameSelector }) => {
    if (!item) return null;

    return (
        <Popup
            offsetTop={offsetTop}
            latitude={parseFloat(item.Latitude)}
            longitude={parseFloat(item.Longitude)}
            closeButton={false}
        >
            <div>{nameSelector(item)}</div>
        </Popup>
    );
};
Tooltip.propTypes = {
    item: PropTypes.object,
    offsetTop: PropTypes.number,
    nameSelector: PropTypes.func.isRequired,
};

export default Tooltip;



// WEBPACK FOOTER //
// ./src/components/map/tooltip.js